// src/firebase-config.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyADOaQuC1yPTP3Uvs00Mhs6L9qgbDa91hU",
    authDomain: "chicago-crimes-420200.firebaseapp.com",
    projectId: "chicago-crimes-420200",
    storageBucket: "chicago-crimes-420200.appspot.com",
    messagingSenderId: "261677296167",
    appId: "1:261677296167:web:f8c42723672546bf92bc02",
    measurementId: "G-969730HYJC"
  };

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
